import ActivityFiltersSkeleton from "@/modules/lead-page/new/components/activity/filters/activity-filters-skeleton";
import { Stack, Skeleton, useTheme } from "@mui/material";

const ActivityHeaderSkeleton = () => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      padding={theme.nawy.spacing.md}
      alignItems="center"
      justifyContent="space-between"
      bgcolor={theme.nawy.colors.semantic.layer.primary}
    >
      <Stack direction="row" alignItems="center" gap={theme.nawy.spacing.xxs}>
        <Skeleton
          variant="text"
          sx={{
            fontSize:
              theme.nawy.typography.english.variants.headline.sm.fontSize,
            lineHeight:
              theme.nawy.typography.english.variants.headline.sm.lineHeight,
            width: 120,
          }}
        />

        <Skeleton
          variant="text"
          sx={{
            fontSize: theme.nawy.typography.english.variants.body.sm.regular,
            lineHeight: theme.nawy.typography.english.variants.body.sm.regular,
            width: 40,
          }}
        />
      </Stack>

      <ActivityFiltersSkeleton />
    </Stack>
  );
};

export default ActivityHeaderSkeleton;
